// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SelectProfilePhotoButton = require("../common/ProfilePicture/SelectProfilePhotoButton.bs.js");
let TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql = require("../../__generated__/TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.bs.js");
let TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql = require("../../__generated__/TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.bs.js");
let TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.bs.js");

let convertFragment = TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateMutation_imageContentType_decode = TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.Utils.imageContentType_decode;

let UpdateMutation_imageContentType_fromString = TeamMarketingProfileTeamPhotoForm_UpdateMutation_graphql.Utils.imageContentType_fromString;

let UpdateMutation = {
  imageContentType_decode: UpdateMutation_imageContentType_decode,
  imageContentType_fromString: UpdateMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$1 = TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.Internal.convertVariables;

let convertResponse$1 = TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, TeamMarketingProfileTeamPhotoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

let acceptedImageTypes = [
  "JPEG",
  "GIF",
  "PNG",
  "WEBP"
];

function parseContentType(contentType) {
  switch (contentType) {
    case "image/gif" :
      return {
        TAG: "Ok",
        _0: "GIF"
      };
    case "image/jpeg" :
      return {
        TAG: "Ok",
        _0: "JPEG"
      };
    case "image/png" :
      return {
        TAG: "Ok",
        _0: "PNG"
      };
    case "image/webp" :
      return {
        TAG: "Ok",
        _0: "WEBP"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnsupportedMimeType",
          VAL: contentType
        }
      };
  }
}

function getImageDimensions(dataUrl) {
  let match = ReasonPromise.pending();
  let resolve = match[1];
  let img = new Image();
  img.src = dataUrl;
  img.addEventListener("load", param => {
    let width = img.width;
    let height = img.height;
    resolve({
      width: width,
      height: height
    });
  });
  return match[0];
}

function TeamMarketingProfileTeamPhotoForm$WithoutErrorBoundary(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileTeamPhotoForm_teamMarketingProfile_graphql.node, convertFragment, props.teamMarketingProfile);
  let match = use$1();
  let runUpdateMutation = match[0];
  let match$1 = use$2();
  let runRemoveMutation = match$1[0];
  let upload = AvatarUploadProvider.useUpload();
  let match$2 = React.useState(() => "InitialState");
  let setState = match$2[1];
  let state = match$2[0];
  let onSelectProfilePhoto = file => {
    setState(param => "Saving");
    let dataUrl = URL.createObjectURL(file);
    let uploadPromise = upload(dataUrl);
    let dimensionsPromise = getImageDimensions(dataUrl);
    ReasonPromise.get(ReasonPromise.all2(uploadPromise, dimensionsPromise), param => {
      let dimensions = param[1];
      let upload = param[0];
      if (upload.TAG === "Ok") {
        let match = upload._0;
        let contentType = parseContentType(match.contentType);
        if (contentType.TAG === "Ok") {
          let contentType$1 = contentType._0;
          runUpdateMutation({
            input: {
              teamPhoto: {
                contentType: contentType$1 === "PNG" ? "PNG" : (
                    contentType$1 === "JPEG" ? "JPEG" : (
                        contentType$1 === "WEBP" ? "WEBP" : "GIF"
                      )
                  ),
                fileName: match.fileName,
                height: dimensions.height,
                key: match.key,
                uploadId: match.id,
                width: dimensions.width
              }
            }
          }, undefined, undefined, undefined, (_response, errors) => {
            if (errors !== undefined) {
              return setState(param => ({
                TAG: "Error",
                _0: "UploadError"
              }));
            } else {
              return setState(param => "InitialState");
            }
          }, _error => setState(param => ({
            TAG: "Error",
            _0: "UploadError"
          })), undefined);
        } else {
          let s = contentType._0.VAL;
          setState(param => ({
            TAG: "Error",
            _0: {
              TAG: "UnsupportedMimeType",
              _0: s
            }
          }));
        }
      } else {
        setState(param => ({
          TAG: "Error",
          _0: "UploadError"
        }));
      }
      URL.revokeObjectURL(dataUrl);
    });
  };
  let onRemovePhoto = () => {
    setState(param => "Saving");
    runRemoveMutation(undefined, undefined, undefined, undefined, (_response, errors) => {
      if (errors !== undefined) {
        return setState(param => ({
          TAG: "Error",
          _0: "RemovePhotoError"
        }));
      } else {
        return setState(param => "InitialState");
      }
    }, _error => setState(param => ({
      TAG: "Error",
      _0: "RemovePhotoError"
    })), undefined);
  };
  let tmp;
  let exit = 0;
  if (typeof state !== "object" && state !== "InitialState") {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$1;
    if (typeof state !== "object") {
      tmp$1 = null;
    } else {
      let tmp$2 = state._0;
      tmp$1 = typeof tmp$2 !== "object" ? (
          tmp$2 === "UploadError" ? JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error updating your photo. Please try again."
            }) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error removing your photo. Please try again."
            })
        ) : JsxRuntime.jsx(Alert.$$Error.make, {
          title: "The selected photo is not supported. Please try another one."
        });
    }
    let photo = marketingProfile.teamPhoto;
    tmp = JsxRuntime.jsxs("div", {
      children: [
        tmp$1,
        photo !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Next__Image.make, {
                src: photo.url,
                width: photo.width,
                height: photo.height,
                unoptimized: true,
                alt: "Your current team photo",
                className: "rounded min-w-0"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                    onSelectProfilePhoto: onSelectProfilePhoto,
                    acceptedImageTypes: acceptedImageTypes,
                    children: "Change photo"
                  }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => onRemovePhoto(),
                    size: "small",
                    children: "Remove photo"
                  })
                ],
                className: "flex flex-col gap-4 items-start md:items-center lg:items-start"
              })
            ],
            className: "flex gap-4 md:items-center lg:items-start md:flex-col lg:flex-row justify-between"
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SelectProfilePhotoButton.make, {
              onSelectProfilePhoto: onSelectProfilePhoto,
              acceptedImageTypes: acceptedImageTypes,
              children: "Select photo"
            })
          })
      ],
      className: "flex flex-col gap-4"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Team photo"
            }),
            JsxRuntime.jsx("small", {
              children: "Upload a group photo that will appear in your marketing profile at full size.",
              className: "text-base text-zinc-500"
            })
          ]
        }),
        className: "pt-2 col-span-2"
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "mt-2 sm:col-span-3 sm:mt-0 "
      })
    ],
    className: "sm:grid sm:grid-cols-5 sm:items-start gap-16 py-6 space-y-6"
  });
}

let WithoutErrorBoundary = {
  make: TeamMarketingProfileTeamPhotoForm$WithoutErrorBoundary
};

function TeamMarketingProfileTeamPhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Team Photo",
    children: JsxRuntime.jsx(TeamMarketingProfileTeamPhotoForm$WithoutErrorBoundary, {
      teamMarketingProfile: props.teamMarketingProfile
    })
  });
}

let Image$1;

let make = TeamMarketingProfileTeamPhotoForm;

exports.Fragment = Fragment;
exports.UpdateMutation = UpdateMutation;
exports.RemoveMutation = RemoveMutation;
exports.acceptedImageTypes = acceptedImageTypes;
exports.parseContentType = parseContentType;
exports.Image = Image$1;
exports.getImageDimensions = getImageDimensions;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
